import React, { Component } from 'react';
import Header from '../.././Header';
import ProjectCard from '.././ProjectCard';
import classnames from 'classnames';

export default class Quora extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"}
    ]

    const work = [
      {title: "Content Quality", subtitle: "Improving content quality through behavioral reinforcement", timespan: "2015", slug: "quora/quality" },
      {title: "Notifications", subtitle: "Redesigning the notifications experience for top writers", timespan: "2014", slug: "quora/notifications" },
      {title: "Growth", subtitle: "Driving growth and retention by optimizing the signup process", timespan: "2013", slug: "quora/growth" },
    ]

    return (
      <div className={classnames('Quora', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-header">
              Quora
            </div>
            <div className="Projects-projects">
              {
                Object.keys(work).map(function(project) {
                  var title = work[project]['title'];
                  var subtitle = work[project]['subtitle'];
                  var timespan = work[project]['timespan'];
                  var slug = work[project]['slug'];
                  return (
                    <ProjectCard
                      title={title}
                      subtitle={subtitle}
                      timespan={timespan}
                      slug={slug}
                    />
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/Quora/index.js